import { Phone } from "lucide-react";
import { BRAND } from "@/lib/site";

/**
 * Floating phone-dialer button. Mobile-only by default.
 * Uses BRAND.callRaw (secondary number) per company spec.
 */
export default function CallButton() {
  return (
    <a
      href={`tel:+${BRAND.callRaw}`}
      data-testid="floating-call-btn"
      aria-label={`Call ${BRAND.phoneSecondary}`}
      className="floating-call-btn flex fixed bottom-6 left-6 z-40 group items-center justify-center w-14 h-14 rounded-full bg-stenzia-green text-white shadow-2xl border border-white/10 hover:scale-110 transition-all"
    >
      <Phone size={20} fill="currentColor" />
      <span className="absolute inset-0 rounded-full bg-stenzia-green/40 opacity-60 animate-ping pointer-events-none" />
    </a>
  );
}
